import React, {useCallback, useRef} from "react"
import {SelectChangeEvent} from "@mui/material"
import {TextModel} from "models/Text"
import SelectSort from "../../selectSort"
import DesktopSortContainer from "../../desktopSortContainer"
import {Sorting} from "../../../../models/Sorting"
import {useSelectDropdown} from "../../../../hooks/useSelectDropdown"
import TrackSortOption from "../../../../events/trackEvent/events/trackSortOption"
import TrackSortOpen from "../../../../events/trackEvent/events/trackSortOpen"

interface Cashmere25DesktopSortProps {
    sortOptions?: Sorting
    onSelect: (value: string) => void
    text: TextModel
}

const Cashmere25DesktopSort = ({sortOptions, onSelect, text}: Cashmere25DesktopSortProps) => {
    const {closeDropdown, openDropdown, showDropdown} = useSelectDropdown()
    const selectRef = useRef<HTMLDivElement>(null)

    const toggleDropdown = useCallback(() => {
        if (showDropdown) {
            closeDropdown()
            if (selectRef.current) {
                selectRef.current.classList.remove("Mui-focused")
            }
        } else {
            openDropdown()
            TrackSortOpen()
        }
    }, [showDropdown, closeDropdown, openDropdown])

    const handleChange = useCallback(
        (event: SelectChangeEvent<any>) => {
            const newValue = event.target.value
            onSelect(newValue)
            TrackSortOption(newValue)
        },
        [onSelect],
    )

    return (
        <DesktopSortContainer>
            <SelectSort
                value={sortOptions?.selected}
                onChange={handleChange}
                open={showDropdown}
                toggleDropdown={toggleDropdown}
                ref={selectRef}
                sortOptions={sortOptions}
                text={text}
            />
        </DesktopSortContainer>
    )
}

export default Cashmere25DesktopSort
